import React from 'react';

function ErrorNote({ error }) {
  return <div className="ErrorNote">{error}</div>;
}
export default ErrorNote;
